import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { doc, getDoc } from "firebase/firestore";

import { Frame, Header, Loading, ValidaUid } from "../components";
import { db } from "../config/firebase";
import Logo from "../assets/logo2.png";

const COLECAO = "ebserh2026";
const WHATSAPP = "(53) 98122-2534";

const Home = () => {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    let componenteAtivo = true;

    const buscarDados = async () => {
      try {
        setLoading(true);
        setErro("");

        const uid = await ValidaUid();

        console.log(uid)

        if (!uid) {
          navigate("/login", { replace: true });
          return;
        }

        const referencia = doc(db, COLECAO, uid);
        const snapshot = await getDoc(referencia);

        if (!componenteAtivo) {
          return;
        }

        if (!snapshot.exists()) {
          setDados(null);
          return;
        }

        setDados({
          ...snapshot.data(),
          uid,
        });
        
      } catch (error) {
        console.error("Erro ao buscar dados:", error);

        if (componenteAtivo) {
          setErro(
            "Não foi possível carregar seus dados. Verifique sua conexão e tente novamente.",
          );
        }
      } finally {
        if (componenteAtivo) {
          setLoading(false);
        }
      }
    };

    buscarDados();

    return () => {
      componenteAtivo = false;
    };
  }, [navigate]);

  const StatusComponent = obterComponenteStatus(dados);

  return (
    <>
      <Header nome={dados?.nome} foto={dados?.urlFoto} />

      {loading ? (
        <Loading />
      ) : erro ? (
        <ErroCarregamento mensagem={erro} />
      ) : (
        <StatusComponent dados={dados} />
      )}
    </>
  );
};

export default Home;

const obterComponenteStatus = (dados) => {
  if (!dados) {
    return Novo;
  }

  if (dados.anoAtual === "2025" && dados.status === "a") {
    return Renovacao;
  }

  const componentesPorStatus = {
    a: Aprovado,
    p: Pendente,
    i: Inativo,
    c: Cancelado,
    d: Devedor,
  };

  return componentesPorStatus[dados.status] ?? Novo;
};

const Novo = () => (
  <Frame
    title="Finalize seu cadastro"
    body={
      <div className="px-3 text-center">
        <p>
          Preencha seus dados para utilizar o nosso serviço de fretamento EBSERH
          2026 - 2027.
        </p>

        <div className="alert alert-warning" role="alert">
          Cadastros realizados antes das 14h estarão aptos para embarque no
          próximo dia útil.
        </div>

        <div className="mt-4 text-end">
          <Link className="btn btn-primary" to="/form1">
            Preencher cadastro
          </Link>
        </div>
      </div>
    }
  />
);

const Renovacao = ({ dados }) => (
  <Frame
    title="Renovação de Contrato"
    body={
      <div className="px-3">
        <p className="text-capitalize">Olá, {dados?.nome}.</p>

        <p>A vigência do seu contrato atual encerra-se em 31/07/2026.</p>

        <p>
          Para continuar utilizando o serviço de fretamento EBSERH no período
          2026/2027, é necessário realizar a renovação do seu contrato.
        </p>

        <p>
          Confira seus dados a seguir e escolha se deseja renovar ou encerrar o
          seu contrato.
        </p>
        <div className="mt-4 text-end">
          <Link className="btn btn-primary" to="/renovacao">
            Iniciar renovação
          </Link>
        </div>
      </div>
    }
  />
);

const Pendente = () => (
  <StatusFrame
    titulo="Cadastro em análise"
    textos={[
      "Aguarde enquanto verificamos a documentação enviada para liberar seu cadastro.",
      "Depois da aprovação, você terá acesso à carteirinha digital e aos demais menus do portal.",
      "Agradecemos por utilizar os nossos serviços.",
    ]}
  />
);

const Inativo = () => (
  <StatusFrame
    titulo="Cadastro inativo"
    textos={[
      "Seu cadastro no serviço de fretamento EBSERH está inativo.",
      `Para solicitar a reativação, entre em contato pelo WhatsApp do fretamento: ${WHATSAPP}.`,
    ]}
  />
);

const Cancelado = () => (
  <StatusFrame
    titulo="Cadastro cancelado"
    textos={[
      "Seu cadastro no serviço de fretamento EBSERH está cancelado.",
      `Para solicitar a reativação, entre em contato pelo WhatsApp do fretamento: ${WHATSAPP}.`,
    ]}
  />
);

const Devedor = () => (
  <StatusFrame
    titulo="Cadastro desativado"
    textos={[
      "Seu cadastro no serviço de fretamento EBSERH está desativado devido a uma pendência financeira.",
      `Por gentileza, entre em contato conosco pelo WhatsApp: ${WHATSAPP}.`,
    ]}
  />
);

const StatusFrame = ({ titulo, textos }) => (
  <Frame
    title={titulo}
    body={
      <div className="px-3">
        {textos.map((texto) => (
          <p key={texto}>{texto}</p>
        ))}
      </div>
    }
  />
);

const ErroCarregamento = ({ mensagem }) => (
  <Frame
    title="Erro ao carregar cadastro"
    body={
      <div className="px-3">
        <div className="alert alert-danger mb-0" role="alert">
          {mensagem}
        </div>
      </div>
    }
  />
);

const Aprovado = ({ dados }) => {
  const campoSaldo = getCampoSaldoMesAtual();
  const saldo = dados?.[campoSaldo] ?? "0";

  return (
    <Frame
      body={
        <div className="text-center">
          <div className="col-12 col-sm-8 col-md-6 mx-auto">
            <img
              src={Logo}
              width={220}
              alt="Logo Expresso Embaixador"
              className="mt-2 img-fluid"
            />

            <h4 className="mt-3 py-2 bg-success bg-gradient text-white rounded">
              FRETAMENTO EBSERH
            </h4>

            <div className="my-3">
              <QRCode
                size={150}
                value={`378|${dados?.uid ?? ""}`}
                aria-label="QR Code da carteirinha"
              />
            </div>

            {dados?.urlFoto ? (
              <img
                src={dados.urlFoto}
                alt={`Foto de ${dados?.nome || "passageiro"}`}
                width={150}
                height={150}
                className="rounded-circle border"
                style={{ objectFit: "cover" }}
              />
            ) : (
              <div
                className="rounded-circle border bg-light d-flex align-items-center justify-content-center mx-auto"
                style={{
                  width: 150,
                  height: 150,
                }}
              >
                <span className="text-muted">Sem foto</span>
              </div>
            )}

            <h4 className="mt-3 py-2 bg-success bg-gradient text-white rounded text-capitalize">
              {dados?.nome || "Nome não informado"}
            </h4>

            <div className="mt-3 text-start fs-5">
              <Info label="CPF" value={dados?.cpf} />
              <Info label="RG" value={dados?.rg} />
              <Info label="Tipo" value={dados?.vinculo} capitalize />
              <Info label="Saldo" value={saldo} />
            </div>
          </div>
        </div>
      }
    />
  );
};

const Info = ({ label, value, capitalize = false }) => (
  <div className={`mt-1 ${capitalize ? "text-capitalize" : ""}`}>
    <span className="fw-bold azul-logo">{label}: </span>
    <span>{value ?? "-"}</span>
  </div>
);

const getCampoSaldoMesAtual = () => {
  const hoje = new Date();
  const mes = String(hoje.getMonth() + 1).padStart(2, "0");
  const ano = String(hoje.getFullYear()).slice(-2);

  return `saldo${mes}${ano}`;
};
